<template>
  <div>
    <a-row style="min-width: 1500px;min-height: 800px">
        <a-col span="8" class="params-form">
          <a-row>
            <a-col span="3">
              <a-button type="primary" @click="lookIndex">返回</a-button>
            </a-col>
            <a-col span="21">
              <div class="title" style="margin-top: 8px">
              农产品查询
            </div>
            </a-col>
          </a-row>
          <a-divider/>
        <a-row>
          <a-space>
            <span>搜索</span>
            <a-input style="width: 300px" v-model="form.searchInput"></a-input>
            <a-button @click="searchTable">搜索</a-button>
          </a-space>
        </a-row>
        <a-row>
          <a-col>
            <div style="height: 20px"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-ext-field-check-box v-model="form.fields"></a-ext-field-check-box>
        </a-row>
        <a-row>
          <a-col>
            <div style="height: 20px"></div>
          </a-col>
        </a-row>
        <a-row>
          <a-table :rowKey="record => record.id" :columns="columns" :data-source="tableData">
            <template slot="type" slot-scope="text, record">
              <div v-if="record.needJudge=='是'"
                   style="display: inline-block;width: 16px;height: 16px;background-color: green;border-radius: 8px">

              </div>
              <div v-else
                   style="display: inline-block;width: 16px;height: 16px;background-color: orange;border-radius: 8px">

              </div>
            </template>
            <template slot="fullName" slot-scope="text, record">
              <a-button type="link" @click="selectNode(record)">{{text+'('+record.path+')'}}</a-button>
            </template>
          </a-table>
        </a-row>
      </a-col>
      <a-col span="5" class="params-form">
        <div class="title">
          农产品分类
          <a-button v-if="publishStatus==='未发布'" @click="onAddProduceItemModalOpen('1')" type="dashed" shape="circle" icon="plus"/>
        </div>

        <a-divider/>
        <div ref="produceTree" class="overflowDiv">
        <a-tree  :show-line="true" :show-icon="false" :tree-data="treeData" :title="{  title: 'title',  }"
                :expandedKeys.sync="expandedKeys" :selectedKeys.sync="selectedKeys" @select="initForm">
          <template slot="title_green" slot-scope="item">
            <p>
              <a-space>
              <span style="display: inline-block;width: 16px;height: 16px;background-color: green;border-radius: 8px">
              </span>
                <span style="display: inline-block;line-height: 16px;font-size: 14px;font-weight: 700;color: #7c7c7c">{{item.title}}</span>
                <a-button v-if="publishStatus==='未发布'" size="small" @click="onAddProduceItemModalOpen(item.path)" type="link" icon="plus"/>
                <a-button v-if="publishStatus==='未发布'" size="small" @click="onDelProduceItem(item.path)" type="link" icon="close"/>
              </a-space>
            </p>
          </template>
          <template slot="title_orange" slot-scope="item">
            <p>
              <a-space>
              <span style="display: inline-block;width: 16px;height: 16px;background-color: orange;border-radius: 8px">
              </span>
                <span style="display: inline-block;line-height: 16px;font-size: 14px;font-weight: 700;color: #7c7c7c">{{item.title}}</span>
                <a-button v-if="publishStatus==='未发布'" size="small" @click="onAddProduceItemModalOpen(item.path)" type="link" icon="plus"/>
                <a-button v-if="publishStatus==='未发布'" size="small" @click="onDelProduceItem(item.path)" type="link" icon="close"/>
              </a-space>
            </p>
          </template>
        </a-tree>
        </div>
      </a-col>
      <a-col span="10" class="params-form">
        <div class="title">
          农产品分类详情
          <a-button v-if="publishStatus==='未发布'" @click="handleOk" type="dashed" shape="circle" icon="save"/>
        </div>
        <a-divider/>

        <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="编号" prop="code">
                <a-input v-model="formState.code"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="是否参与判定标准" prop="needJudge">
                <a-radio-group v-model="formState.needJudge">
                  <a-radio value="是">
                    是
                  </a-radio>
                  <a-radio value="否">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="中文名称" prop="cn">
                <a-input v-model="formState.cn"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="英文名称" prop="en">
                <a-input v-model="formState.en"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="拉丁名称" prop="ld">
                <a-input v-model="formState.ld"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="中文别名" prop="nick">
                <a-input v-model="formState.nick"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="GEMS编码" prop="gems">
                <a-input v-model="formState.gems"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="FOODEX_2编码" prop="foodex2">
                <a-input v-model="formState.foodex2"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="照片" prop="zhaopian">
                <a-ext-upload v-model="formState.zhaopian"></a-ext-upload>
              </a-form-model-item>
            </a-col>
          </a-row>


          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="描述" prop="remark">
                <a-input v-model="formState.remark"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col span="24">
              <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属行业" prop="hangye">
                <a-ext-local-dic-select dic-key="HangYe" v-model="formState.hangye"></a-ext-local-dic-select>
              </a-form-model-item>
            </a-col>
          </a-row>

        </a-form-model>
      </a-col>
    </a-row>
    <add-produce-item v-if="addProduceItemModalVisable" :visible.sync="addProduceItemModalVisable"
                      :param="addProduceItemModalParam"
                      @addStdProduceModalClose="onStdProduceItemModalClose"></add-produce-item>

  </div>
</template>

<script>
import AExtFieldCheckBox from '../../../components/AntDesignExt/All/AExtFieldCheckBox'
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import AddProduceItem from './AddProduceItem'
import {addorUpdateStdProduceItem as saveApi, getStdProduceItemById as initApi} from '../../../api/api'
import {searchProduceItem, searchProduceItemTree, delStdProduceItemSelected} from '../../../api/api'
import {FormRules} from 'antd-form-rules';

export default {
    name: "index2",
    components: {AExtFieldCheckBox, AExtLocalDicSelect, AExtUpload, AddProduceItem},
    props:{
        stdId:{
            type:String,
            default:''
        },
        publishStatus:{
            type:String,
            default: ''
        }
    },
    data() {
        return {
            form: {
                searchInput: '',
                fields: 'cn,nick',
            },
            belongId:'',
            tableData: [],
            treeData: [],
            expandedKeys: [],
            selectedKeys: [],
            columns: [
                {
                    title: '类型',
                    dataIndex: 'needJudge',
                    width: '100px',
                    scopedSlots: {customRender: 'type'},
                },
                {
                    title: '名称',
                    dataIndex: 'cn',
                    width: '100%',
                    scopedSlots: {customRender: 'fullName'},
                }],
            confirmLoading: false,
            formState: {
                code: '',
                need_judge: '',
                cn: '',
                en: '',
                ld: '',
                nick: '',
                gems: '',
                foodex2: '',
                remark: '',
                zhaopian: {},
                orderby: '',
                hangye: '',
            },
            rules: {
                code: FormRules.withName('编号').string(1, 200).isRequired().create(),
                needJudge: FormRules.withName('是否参与标准').string(1, 50).isRequired().create(),
                cn: FormRules.withName('中文名').string(1, 200).isRequired().create(),
            },
            addProduceItemModalVisable: false,
            addProduceItemModalBackChange: null,
            addProduceItemModalParam: null
        }
    },
    created() {
        this.belongId=this.stdId;
        this.initTree();
    },
    methods: {
        initForm(keys) {
            if (keys && keys.length) {
                this.confirmLoading = true;
                initApi({belongId:this.belongId,path:keys[0]}).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.formState.belongId=this.belongId;
                    saveApi(this.formState).then((result => {
                        this.confirmLoading = false;
                        this.updateTree(this.treeData, this.formState);
                        this.success()
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        initTree() {
            searchProduceItemTree(this.belongId).then((result => {
                if (result.data && result.data.data) {
                    this.insertSlot(result.data.data);
                    if (this.expandedKeys && this.expandedKeys.length === 0) {
                        let expandKeys = [];
                        result.data.data.forEach(item => {
                            expandKeys.push(item.key);
                            // if(item.children&&item.children.length)
                            // {
                            //     item.children.forEach(item2=>{
                            //         expandKeys.push(item2.key);
                            //     })
                            // }
                        });
                        this.expandedKeys = expandKeys;
                    }
                    this.treeData = result.data.data

                }
                else {
                    this.treeData = [];
                }

            })).catch(() => {
            });
        },
        searchTable() {
            this.form.belongId=this.belongId;
            searchProduceItem(this.form).then((result => {
                if (result.data && result.data.data) {
                    this.tableData = result.data.data;

                }
                else {
                    this.tableData = [];
                }

            })).catch(() => {
            });
        },
        insertSlot(list) {
            list.map(item => {
                if (item.hasOwnProperty('children') && item.children && item.children.length > 0) {
                    this.insertSlot(item.children);
                }
                if (item.needJudge === '是') {
                    item.scopedSlots = {title: 'title_green'};
                }
                else {
                    item.scopedSlots = {title: 'title_orange'};
                }
                return item;
            })
        },
        onAddProduceItemModalOpen(ppath) {
            if (!ppath) {
                ppath = '1';
            }
            this.addProduceItemModalParam = {belongId:this.belongId,ppath: ppath};
            this.addProduceItemModalVisable = true;
            //TODO: 无
        },
        onDelProduceItem(path) {

            let sucFun=this.success;
            let initTFun=this.initTree;
            let belongId=this.belongId;
            this.$confirm({
                title: '确定要删除吗?',
                content: '删除后数据无法恢复，请谨慎删除！',
                onOk() {
                    delStdProduceItemSelected({belongId:belongId,path:path}).then((result => {
                        if (result.data && result.data.data) {
                            sucFun();
                            initTFun();
                        }
                    }));
                },
                onCancel() {},
            });


        },
        onStdProduceItemModalClose() {
            //TODO: 无
            this.initTree();
        },
        success(updateItem) {
            this.$message.success(
                '操作成功',
                2,
            );
        },
        updateTree(list, updateItem) {
            list.map(item => {
                if (item.hasOwnProperty('children') && item.children && item.children.length > 0) {
                    this.updateTree(item.children, updateItem);
                }
                if (item.path === updateItem.path) {
                    item.title = updateItem.cn + '(' + updateItem.code + ')';
                }
                return item;
            })
        },
        selectNode(item)
        {
            for (let i=0;;i++)
            {
                let key=item.path.substr(0,item.path.length-i*3);
                if(this.selectedKeys.indexOf(key)===-1){
                    this.expandedKeys.push(key);
                }
                if(key.length<5)
                {
                    break;
                }
            }


            if(this.selectedKeys.indexOf(item.path)===-1){
                this.selectedKeys=[item.path];
            }

            setTimeout(() => {
                if(document.getElementsByClassName('ant-tree-treenode-checkbox-checked').length>0){
                    document.getElementsByClassName('ant-tree-treenode-checkbox-checked')[0].scrollIntoView()
                }
                if(document.getElementsByClassName('ant-tree-treenode-selected').length>0){
                    document.getElementsByClassName('ant-tree-treenode-selected')[0].scrollIntoView()
                }
            }, 500);
        },
        lookIndex(record)
        {
            this.$emit('fanhui',null)
        }
    }
}
</script>

<style scoped>
  .params-form {
    margin: 10px;
    padding: 20px;
    height: calc(100vh - 200px);
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    box-shadow: #1b2f7017 0px 2px 4px 2px;
    min-height: 800px;
  }

  .overflowDiv{
    height: calc(100vh - 300px);
    overflow-y: auto;
    min-height: 700px;
  }

  .title {
    padding-left: 12px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    color: rgba(0, 0, 0, 0.85);
    position: relative;
    margin-bottom: 16px;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }

  .title::before {
    content: '';
    position: absolute;
    height: 16px;
    top: calc(50% - 8px);
    left: 0px;
    width: 3px;
    background-color: rgb(36, 113, 210);
  }
</style>